<template minapp="mpx" xlang="wxml">
  <view>
    <notes class="notes1" isShowTabIcon="{{isShowTabIcon}}" notesList="{{notesList}}">
      <view slot="tabrefund">
        <ticket-table tableValue="{{tableValue1}}"></ticket-table>
        <ticket-table tableValue="{{tableValue2}}"></ticket-table>
      </view>
    </notes>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  createComponent({
    data: {
      isShowTabIcon: true,
      title1: '怎么乘车？',
      listText1: [
        [
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '1.旅客必须持有有效车票并按票面载明的日期、车次、席别乘车，'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #FF6221;'
            },
            children: [
              {
                type: 'text',
                text: '同时携带有效的出入境证件及签注'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '。'
              }
            ]
          }
        ],
        [
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '2.建议于列车出发前至少45分钟到站办理出入境手续。'
              }
            ]
          }
        ],
        [
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '3.如果旅客的乘车凭证是购票时使用的有效身份证件，可持对应的有效身份证件直接检票乘车，无需换车票。'
              }
            ]
          }
        ]
      ],
      title2: '改签规则是什么？',
      listText2: [
        [
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '1.车票改签后，'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #FF6221;'
            },
            children: [
              {
                type: 'text',
                text: '无法退票'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '。'
              }
            ]
          }
        ],
        [
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '2.旅客'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #FF6221;'
            },
            children: [
              {
                type: 'text',
                text: '仅可办理一次改签'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '，且无法'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #FF6221;'
            },
            children: [
              {
                type: 'text',
                text: '变更到站'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '。'
              }
            ]
          }
        ],
        [
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '3.改签后的车票票价高于原车票票价时，补收差额；低于原车票票价时，退还差额。不收取手续费。'
              }
            ]
          }
        ],
        [
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '4.办理改签'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #FF6221;'
            },
            children: [
              {
                type: 'text',
                text: '不可晚于列车发车前30分钟'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '，发站为香港西九龙站的车票'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #FF6221;'
            },
            children: [
              {
                type: 'text',
                text: '应不晚于发车前45分钟'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '。'
              }
            ]
          }
        ]
      ],
      notesList: [
        {
          title: '余票数说明',
          list: [
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '余票数据动态调整，仅供参考'
                  }
                ]
              }
            ]
          ]
        },
        {
          title: '进站出站说明',
          list: [
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '【已开通电子客票车站】2020 年 6 月起，乘客可直接刷身份证进出站，无需取票'
                  }
                ]
              }
            ],
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '【未开通电子客票车站】保持原有进出站模式，需在发车前使用购票时证件原件，在车站取票后进出站'
                  }
                ]
              }
            ]
          ]
        },
        {
          title: '报销凭证说明',
          list: [
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '票款费用报销凭证：火车票纸质票'
                  }
                ]
              }
            ],
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '退改手续费报销凭证：手续费发票'
                  }
                ]
              }
            ],
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '领取方式：凭购票时所使用的有效身份证件到车站售票窗口、自动售票机换取'
                  }
                ]
              }
            ],
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '领取时效：在开车前或乘车日期之日起180日以内都可领取报销凭证'
                  }
                ]
              }
            ]
          ]
        }
      ],
      tableValue1: {
        title: '发车前取票方式说明',
        tableth: ['取票类型', '如何取票'],
        tablelist: [
          {
            title: '二代身份证',
            content: [
              {
                submit_title: '取票条件：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '二代身份证原件'
                      }
                    ]
                  }
                ]
              },
              {
                submit_title: '取票地点：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '车站售票窗口、车站自动售取票机、代售点'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            title: '护照、台胞证、回乡证',
            content: [
              {
                submit_title: '取票条件：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '购票证件原件+E开头的取票号'
                      }
                    ]
                  }
                ]
              },
              {
                submit_title: '取票地点：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '车站售票窗口、代售点'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            title: '学生票',
            content: [
              {
                submit_title: '取票条件：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '购票证件原件+'
                      }
                    ]
                  },
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #1473FF;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '学生优惠卡'
                      }
                    ]
                  }
                ]
              },
              {
                submit_title: '取票地点：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '车站售票窗口、车站自动售取票机'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            title: '儿童票',
            content: [
              {
                submit_title: '取票条件：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '凭购票时'
                      }
                    ]
                  },
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #1473FF;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '所用儿童本人有效证件的原件'
                      }
                    ]
                  }
                ]
              },
              {
                submit_title: '取票地点：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '车站售票窗口、车站自动售取票机、代售点'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      tableValue2: {
        title: '特殊取票方式说明',
        tableth: ['取票类型', '如何取票'],
        tablelist: [
          {
            title: '有效身份证丢失取票',
            content: [
              {
                submit_title: '取票条件：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '携带能证明身份的相关证件（如户口本、驾驶证、社保卡等）至车站公安窗口办理办理临时身份证明'
                      }
                    ]
                  }
                ]
              },
              {
                submit_title: '取票地点：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '车站售票窗口'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            title: '证件消磁取票',
            content: [
              {
                submit_title: '取票条件：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '购票证件原件+E开头的取票号'
                      }
                    ]
                  }
                ]
              },
              {
                submit_title: '取票地点：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '车站售票窗口、代售点'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            title: '过期车票取票',
            content: [
              {
                submit_title: '取票条件：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '购票证件原件+E开头的取票号'
                      }
                    ]
                  }
                ]
              },
              {
                submit_title: '取票地点：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '车站售票窗口'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    mounted() {},
    computed: {},

    methods: {}
  })
</script>

<style scoped lang="stylus">
  .notes1
    border-radius 8px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      explain: '@/components/ticket-guide/explain',
      notes: '@/components/ticket-guide/notes',
      'ticket-table': '@/components/ticket-guide/ticket-table'
    }
  }
</script>